import { api } from '@/shared/lib/axios.ts';
import type { DashboardData } from '@/shared/types/dashboard.ts';

export async function getDashboard(): Promise<DashboardData> {
  const { data } = await api.get<DashboardData>('/admin/dashboard');
  return data;
}
